import React, { Component, Fragment } from 'react';
import $ from 'jquery';
import { isGoogleDocUrl, isGoogleSlideUrl, shouldEmbedIframe } from '../utilities/iframeUtilities';
import { getBlockPosition } from '../utilities/selectionUtilities';
import { KEYCODE } from '../utilities/CONSTANTS';

class EmbedlyDialog extends Component {
    constructor(props) {
        super(props);

        this.textInput = React.createRef();

        this.state = {
            link: null,
            blockPosition: {
                top: 0,
                left: 0,
            },
        };
    }

    componentDidMount() {
        this.setBlockPosition();
        setTimeout(() => this.textInput.current.focus(), 1);
        document.body.addEventListener('click', this.clickHandler);
    }

    onChange = e => this.setState({ link: e.target.value });

    onKeyDown = (e) => {
        if (e.which === KEYCODE.enter) {
            this.insertEmbed(this.state.link);
            this.closeDialog();
        } else if (e.which === KEYCODE.escape) {
            this.closeDialog();
        }
    };

    insertEmbed = (url) => {
        if (shouldEmbedIframe(url)) {
            if (isGoogleSlideUrl(url)) {
                const embedUrl = url.replace('/edit', '/embed');

                return this.props.insertIframe(embedUrl);
            }

            if (isGoogleDocUrl(url)) {
                const minimalUrl = url.includes('?') ? `${url}&rm=minimal` : url.replace('/edit', '?rm=minimal');

                return this.props.insertIframe(minimalUrl);
            }
            return this.props.insertIframe(url);
        }
        return this.props.insertEmbedly(url);
    };

    clickHandler = (e) => {
        const $target = $(e.target);
        if (!$target.is('.link-dialog') && !$target.parents().is('.link-dialog')) {
            this.closeDialog();
        }
    };

    closeDialog = () => {
        document.body.removeEventListener('click', this.clickHandler);
        this.props.toggleEmbedlyDialog(false);
    };

    setBlockPosition = () => {
        const { editorState } = this.props;
        const { blockPosition } = this.state;
        const newPos = getBlockPosition(editorState);
        if (newPos != null && (newPos.left != blockPosition.left || newPos.top != blockPosition.top)) {
            this.setState({ blockPosition: newPos });
        }
    };

    getPosition = () => {
        const { blockPosition } = this.state;

        if (blockPosition == null || blockPosition.top == 0) {
            return null;
        }

        const containerNode = document.getElementById('post-editor-content');
        const containerNodeBounding = containerNode.getBoundingClientRect();
        const titleNode = document.getElementById('post-editor-title');
        const titleNodeBounding = titleNode.getBoundingClientRect();
        const { height: titleHeight } = titleNodeBounding;
        return ({
            left: -25,
            top: blockPosition.top - containerNodeBounding.y + titleHeight - 19,
        });
    };

    render() {
        const position = this.getPosition();

        if (position == null) return null;

        const caretPosition = {
            ...position,
            top: position.top + 5,
            left: position.left + 21,
        };

        return (
            <div className="link-dialog z5" style={position}>
                <input
                    ref={this.textInput}
                    className="link-edit-display"
                    type="text"
                    placeholder="https://www.youtube.com"
                    onChange={this.onChange}
                    onKeyDown={this.onKeyDown}
                />
                <button
                    className="link-edit-button"
                    onMouseDown={this.closeDialog}
                >
                        &times;
                </button>
            </div>
        );
    }
}

export default EmbedlyDialog;
